import { LocaleMessages } from '@intlify/core-base';
import { VueMessageType } from 'vue-i18n';

export const en: LocaleMessages<VueMessageType> = {
  message: {
    continue: 'Continue',
    mandatory_field: '* Required field',
    mandatory_char: ' *',
    email_address: 'Email address',
    name: 'Name',
    surname: 'Last name',
    birthday: 'Birthdate',
    phoneNumber: 'Phone Number',
    dd: 'GG',
    mm: 'MM',
    yyyy: 'YYYY',
    defaultYearBirthdate: '1980',
    profilingPermission: 'Profiling policy',
    marketingPermission: 'Marketing policy',
    thirdPermission: 'Stay updated on the world of Neos and VOIhotels',
    register: 'Register',
    password: 'Password',
    signin: 'Login',
    error: 'Sorry, something went wrong, please try again later.',
    forgot_password: 'Forgot your password?',
    not_register: 'Not Signed Up yet?',
    repeat_password: 'Repeat Password',
    sign_up_email_sent: 'The link to confirm your registration has been sent to your email address {email}. If you don\'t see it in your inbox, please check your spam folder as well. If the link hasn\'t arrived after a few minutes, we recommend not repeating the registration process and instead contacting us at area.riservata{\'@\'}alpitourworld.it, where our support team will be happy to assist you.',
    confirmation_sign_up_success_message: 'Registration completed successfully',
    confirmation_sign_up_error_message: 'Verification code expired, couldn\'t confirm {email}',
    sign_in_title: 'Log in or register in the reserved area',
    sign_in_error: 'Please try again later.',
    sign_in_not_authorized_error: 'Invalid credentials',
    sign_in_user_not_found_error: 'Sorry, your credentials do not appear correct. If you have registered in the past, try logging in using social media.',
    sign_in_3_time_limit: 'We\'re sorry something went wrong. We ask you to contact assistance by writing to "area.riservata{\'@\'}alpitourworld.it" detailing the problem encountered',
    sign_in_try_later_error: 'Please try again later.',
    sign_in_user_not_confirmed_error: 'Check your email to complete the registration process',
    logout_success: 'You were logged out successfully',
    logout_error: 'Please try again later.',
    sign_up_error: 'Please try again later.',
    send_password: 'Send password',
    forgot_password_title: 'Password Recovery',
    forgot_password_info: 'To reset your password, enter your email and confirm. An email will be sent to you with instructions to complete the process',
    forgot_password_success: 'The link to reset your password has been sent to your email address {email}. If you don\'t see it in your inbox, please also check your spam folder. If the link hasn\'t arrived after a few minutes, we recommend not repeating the password reset procedure and instead contacting us at area.riservata{\'@\'}alpitourworld.it, where our support team will be happy to assist you.',
    forgot_password_error: 'Please try again later.',
    forgot_password_try_social: 'Sorry, something went wrong. If you have registered in the past, try logging in using social media.',
    forgot_password_generic_error: 'Oops something went wrong: Please try again later',
    restore_password: 'Confirm',
    reset_password_title: 'Reset Password',
    reset_password_success: 'Your password was successfully reset',
    reset_password_error: 'Verification code expired, couldn\'t reset password.',
    reset_password_required: 'Reset password required.',
    confirm_password: 'Confirm',
    user_already_exists_error: 'You have already signed up with one of the following services: alpitour.it, edenviaggi.it, turisanda.it',
    date_format: '{year}-{month}-{day}',
    registration_title: 'Registration to MyAlpitourWorld',
    complete_federated_login_title: 'Complete your registration',
    invalid_password: 'Invalid password',
    password_policy_title: 'Must contain atleast:',
    password_policy_spaces: 'Must not start or end with spaces',
    password_policy_length: '8 characters',
    password_policy_lowercase: '1 lowercase character',
    password_policy_uppercase: '1 uppercase character',
    password_policy_number: '1 numeric character',
    password_policy_special: '1 special character',
    under_age: 'You must be of legal age',
    invalid_birthdate: 'Invalid birthdate',
    invalid_phone_number: 'Phone number already used',
    or_access_with: 'Or access with',
    marketing_consent_description_not_expanded: 'I consent to the processing of my personal data for direct marketing purposes using both automated and non-automated tools',
    marketing_consent_description_expanded: 'I consent to the processing of my personal data for the purpose of receiving, via automated tools (e.g., email; operator-free phone - such as SMS, MMS, push notifications) and non-automated tools (e.g., postal mail; operator-assisted phone), newsletters and promotional communications regarding Alpitour products and initiatives, as well as those of third parties offering tourism and/or supplementary tourism services, including other companies in the Alpitour Group. This also includes activities aimed at conducting market research and participating in prize contests and events organized by Alpitour and the aforementioned third parties',
    profiling_consent_description_not_expanded: 'I consent to the processing of my personal data for profiling purposes and to receive personalized communications',
    profiling_consent_description_expanded: 'I consent to the processing of my personal data to analyze the details of my purchases (e.g., types of payment methods, my responses to market research, purchase volume, travel destinations, etc.) and/or my browsing and platform usage behavior on the websites and the Application, in order to create a profile of my preferences for statistical, commercial, and marketing purposes',
    third_consent_description_not_expanded: 'I consent to the communication of my personal data to other companies of the Alpitour Group for marketing purposes',
    third_consent_description_expanded: 'I consent to the communication of my personal data to other companies of the Alpitour Group for the purpose of sending newsletters and promotional communications about their products and initiatives using automated tools (the list of the companies of the Group receiving the communication is available on the Data Controller’s website - privacy area)',
    read_more: 'Read all',
    hide: 'Hide',
    sign_in_privacy_terms: 'Read the <a class="underline" target="_blank" href="{privacyUrl}">privacy policy</a>&nbsp',
    sign_in_general_conditions: 'and the <a class="underline" target="_blank" href="{generalConditionsUrl}">general conditions</a>',
    sign_up_privacy_policy: 'I also declare that I have read the <a class="underline" style="color:{color}" class="font-bold" target="_blank" href="{privacyUrl}">privacy policy</a>.',
    sign_up_general_conditions: 'By registering in the reserved area, I accept: <br> the <a class="underline" style="color:{color}" class="font-bold" target="_blank" href="{generalConditionsUrl}">general conditions</a>&nbsp',
    sign_up_vexatious_clauses: 'and the vexatious clauses.&nbsp',
    hat_trick_message: 'You are already registered but with a different email',
    crm_existing_email: 'You have already signed up with this email, try to log in or recover your password',
    otp_page_title: 'Verify your account with OTP',
    select_otp_type: 'Select the authentication type',
    otp_send_mail: 'An email will be sent to',
    otp_send_phone: 'A text message will be sent to the number',
    insert_otp: 'Enter the code received via ',
    send_otp_error: 'Error occured sending the otp code! If the problem persists, please contact assistance: "area.riservata{\'@\'}alpitourworld.it"',
    confirm_otp_error: 'Error occured during otp confirmation! If the problem persists, please contact assistance: "area.riservata{\'@\'}alpitourworld.it"',
    otp_code: 'OTP Code',
    email: 'E-mail',
    phone: 'Phone',
    get_user_contacts: 'An error occurred while retrieving the contacts associated with your user account! If the problem persists, contact support: Area.riservata{\'@\'}alpitourworld.it',
    otp_duration: 'The code lasts 15 minutes',
    back_to_login: 'Back to login',
    unknown_contacts: 'If you don\'t recognize the suggested contacts, they may be from your trusted travel agency',
    otp_support: 'Are you having trouble recovering your account? Write to "area.riservata{\'@\'}alpitourworld.it" for assistance',
    send_again: 'Send again',
    crm_phone_not_allowed: 'The number entered is invalid. Please check that you are not including the international area code (select it from the drop-down menu). For assistance: area.riservata{\'@\'}alpitourworld.it',
    crm_phone_used: 'The number is already associated with another profile. Try again without entering it. For support: area.riservata{\'@\'}alpitourworld.it',
    crm_phone_not_congruent: 'The number appears to be registered but does not match the master data provided. Try again without entering it. For assistance: area.riservata{\'@\'}alpitourworld.it',
    crm_incongruent_data: 'The number entered is invalid. Please verify that you are not including the country code. For support: area.riservata{\'@\'}alpitourworld.it',
    // Accessibility
    accessibility: {
      email_required: 'Email required',
      email_invalid: 'Invalid email',
      name_required: 'Name required',
      name_invalid: 'Invalid name',
      surname_required: 'Surname required',
      surname_invalid: 'Invalid surname',
      birthdate_missing: 'Birthdate missing',
      password_required: 'Password required',
      password_invalid: 'Invalid password: check requirements',
      confirm_password_required: 'Password confirmation required',
      passwords_not_match: 'Passwords do not match',
      phone_required: 'Phone number required',
      fix_errors: 'Fix the following errors: {errors}',
      form_complete: 'The form is now complete. You can proceed with registration.',
      password_valid: 'Valid password',
      password_requirements_missing: 'Missing requirements: {requirements}',
      requirement_met: 'met',
      requirement_not_met: 'not met',
      password_requirements_label: 'Password requirements',
      password_requirements_list: 'Password requirements list',
      progress_label: '{current} requirements out of {total} met',
      password_requirements: 'Password Requirements',
      login_with_facebook: 'Log in with Facebook',
      login_with_google: 'Log in with Google',
      login_with_apple: 'Log in with Apple',
      go_back: 'Go back'
    }
  }
};
